import React, { useEffect } from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Badge from "@mui/material/Badge";
import ManageSearch from "@mui/icons-material/Search";
import EndGame from "@mui/icons-material/ExitToApp";
import StarIcon from "@mui/icons-material/Star";
import ShareIcon from "@mui/icons-material/Share";
import Drawer from "./../../components/Drawer";
import ContentTypes from "../../services/Content";
import GenericContent from "../../services/GenericContent";
import PlayerService from "../../services/PlayerService";
import ShareGame from "../../components/ShareGame";
import Dice from "../../components/Dice/Index";
import PopupMessage from "../../components/PopupMessage";
import IconButton from "@mui/material/IconButton";
import ApiCommonContent from "../../services/GenericContent";
import Firebase from "../../services/Firebase";
import lodash from "lodash";
import "./styles.scss";
import GameOverPopup from "./../../components/GameOver";
import * as PIXI from "pixi.js";
import { AppProvider } from "@pixi/react";
import CssBaseline from "@mui/material/CssBaseline";
import MContainer from "@mui/material/Container";
import GameBoard from "./../../components/Board/Game";
import StartGame from "./../../components/StartGameModal";
import Separador from "./../../assets/images/generic/separadorClaro.png";
import FinishIcon from "./../../assets/images/trophies/JuegoMujeres_trophy_yellow.png";

import {
  ButtonTypes,
  CommonContent,
  Content,
  ContentKey,
} from "../../types/Types";
import UserSession from "./../../services/UserSession";
import GameHelper from "./../../services/GameHelper";
import CircularAvarar from "./../../components/CircularAvarar";
import { useNavigate } from "react-router-dom";
import {
  GameDetails,
  GameMode,
  GameStatus,
  PlayerDetails,
  PlayersEvent,
  UserAccount,
} from "../../types/Game";
import { Parser } from "html-to-react";
import { Alert, Avatar, Snackbar } from "@mui/material";
import { Layers } from "@mui/icons-material";
import GameApi from "../../services/GameApi";

type HeaderProps = {
  content: CommonContent[];
  avatar: string;
  player?: PlayerDetails,
  name: string;
  points: number;
  magnifyingGlass: number;
  showInvite: boolean;
  showEndGame: boolean;
  gameId: string;
  gameOver: boolean;
  onOpenInvite: () => void;
  onCloseInvite: () => void;
  onShowEndGame: () => void;
  onConfirmEndGame: () => void;
  onCancelEndGame: () => void;
};

type FooterProps = {
  onOpenInvite: () => void;
  players: PlayerDetails[];
  game: GameDetails;
  user: UserAccount;
  content: CommonContent[];
  gameOver: boolean;
};

const HeaderAppBar = (props: HeaderProps) => {
  const navigate = useNavigate();
  const leaveGameTitle = ApiCommonContent.getKeyValue(
    props.content,
    ContentKey.LEAVE_GAME
  );
  const leaveGameConfirmation = ApiCommonContent.getKeyValue(
    props.content,
    ContentKey.LEAVE_GAME_CONFIRMATION
  );

  const ok = Parser().parse(
    ApiCommonContent.getKeyValue(props.content, ContentKey.OK_LABEL)
  );

  const cancel = ApiCommonContent.getButtonName(
    props.content,
    ButtonTypes.CANCEL
  );

  const handleClick = () => {
    navigate("/myprofile");
  };

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="static" className="topBarGame">
        <Toolbar>
          <Drawer />
          <Typography
            variant="h2"
            component="div"
            sx={{ flexGrow: 1 }}
          ></Typography>

          <IconButton
            onClick={() => {
              props.onOpenInvite();
            }}
          >
            <ShareIcon style={{ color: "#243e3d " }} />
          </IconButton>

          <Badge
            className="gameHeaderBadgeIcon"
            badgeContent={props.points}
            color="primary"
          >
            <StarIcon className="gameHeaderIcon" />
          </Badge>

          <Badge
            className="gameHeaderBadgeIcon"
            badgeContent={props.magnifyingGlass}
            color="primary"
          >
            <ManageSearch className="gameHeaderIcon" />
          </Badge>

          <CircularAvarar
            badgeContent={props.points}
            onClick={handleClick}
            width={70}
            height={70}
            url={props.avatar}
            showThrophy={ props.player && PlayerService.hasPlayerFinished(props.player)}
          />
          <IconButton
            style={{ zIndex: 9999 }}
            onClick={() => {
              props.onShowEndGame();
            }}
          >
            <EndGame className="gameHeaderIconExit" />
          </IconButton>
        </Toolbar>
      </AppBar>
      <ShareGame
        content={props.content}
        visible={props.showInvite}
        onCloseInvite={props.onCloseInvite}
        gameId={props.gameId}
      />

      <PopupMessage
        cancel={cancel}
        ok={ok}
        title={leaveGameTitle}
        description={leaveGameConfirmation}
        visible={props.showEndGame}
        onConfirm={props.onConfirmEndGame}
        onCancel={props.onCancelEndGame}
      />
    </Box>
  );
};

const FoterAppBar = (props: FooterProps) => {
  const { players, onOpenInvite } = props;

  const getDiceNumbers = () =>
    props.game?.diceResult && props.game.diceResult.length >= 1
      ? props.game.diceResult
      : [0, 0];
  const showDiceResult = () =>
    props.game?.diceResult && props.game.diceResult.length >= 1;
  return (
    <Box sx={{ flexGrow: 1 }}>
      <div className="playersContainer">
        {players.map((player, index) => (
          <>
            <div key={index} className="playerColumn">
              <CircularAvarar
                onClick={() => {}}
                width={50}
                height={50}
                url={player.profileUrl}
                title={player.name}
                showThrophy={PlayerService.hasPlayerFinished(player)}
              />
              {!PlayerService.isPlayerThrowingDice(player, props.game) && (
                <label><span>{player.name}</span></label>
              )}
              
              {PlayerService.isPlayerThrowingDice(player, props.game) &&
                !props.gameOver && (
                  <Dice
                    numberOfDices={PlayerService.getNumberOfDices(player.boardPosition)}
                    diceSideNumbers={getDiceNumbers()}
                    showDiceResult={showDiceResult()}
                    throwDice={true}
                  />
                )}
            </div>
            {index < 3 && <img width={6} height={200} src={Separador} />}
          </>
        ))}
        {players.length < 4 && props.game.mode === GameMode.PlayWithFriends && (
          <div className="playerColumn">
            <Avatar className="shareiconAvatar">
              <ShareIcon style={{ color: "#000" }} />
            </Avatar>
            <label onClick={() => onOpenInvite()} className="labelInvite">
              <span>{GenericContent.getKeyValue(
                props.content,
                ContentKey.INVITE_PLAYERS
              )}</span>
            </label>
          </div>
        )}
      </div>
    </Box>
  );
};

const pixiApp = new PIXI.Application({
  resolution: window.devicePixelRatio || 1,
  autoDensity: true,
});
const GameScreen = () => {
  const navigate = useNavigate();
  const [commonContent, setCommonContent] = React.useState<CommonContent[]>();
  const [content, setContent] = React.useState<Content[]>();
  const [user, setUser] = React.useState<UserAccount | null>(null);
  const [invitePlayers, setInvitePlayers] = React.useState<boolean>(false);
  const [showEndGame, setShowEndGame] = React.useState<boolean>(false);
  const [waitFriends, setWaitFriends] = React.useState<boolean>(false);
  const [newPlayer, setNewPlayer] = React.useState<PlayerDetails | null>(null);
  const [notifyNewPlayer, setNotifyNewPlayer] = React.useState<boolean>(false);
  const [gameId, setGameId] = React.useState("");
  const [players, setPlayers] = React.useState<PlayerDetails[] | null>(null);
  const [game, setGame] = React.useState<GameDetails | null>(null);
  const [gameOver, setGameOver] = React.useState<boolean>(false);

  useEffect(() => {
    if (!user) {
      UserSession.getSession()
        .then((user) => {
          if (!user) {
            console.error("There is not user created in local storage");
            navigate("/");
          } else {
            setUser(user);
          }
        })
        .catch((e) => console.error(e));
    }
  }, [user]);

  useEffect(() => {
    if (!content) {
      ContentTypes.getContent().then((con) => {
        setContent(con);
        console.log(" Content:", content);
      });
    }
  }, [content]);

  useEffect(() => {
    if (!commonContent) {
      GenericContent.getContent().then((comcon) => {
        setCommonContent(comcon);
        console.log("Common Content:", content);
      });
    }
  }, [commonContent]);

  useEffect(() => {
    if (!gameId) {
      GameHelper.getCurrentGameId().then((id) => {
        if (id) {
          setGameId(id);
          loadGame(id)
            .then(() => {})
            .catch((e) => console.error(e));
        } else {
          console.error("There is not game created in local storage");
          navigate("/");
        }
      });
    }
  }, [gameId, user]);

  useEffect(() => {
    if (gameId) {
      pullPlayers(gameId)
        .then()
        .catch((e) => console.error(e));
    }
  }, [newPlayer]);

  useEffect(() => {
    checkGameOver();
  });

  useEffect(() => {
    checkGameStart();
  }, [user, newPlayer, players, game]);

  const onOpenInvite = () => {
    setInvitePlayers(true);
  };

  const onCloseInvite = () => {
    setInvitePlayers(false);
  };

  const onCancelEndGame = () => {
    setShowEndGame(false);
  };

  const onConfirmEndGame = async () => {
    await Firebase.removePlayerFromGame(user?.userId || "", gameId);
    await GameHelper.removeCurrentGame();
    navigate("/game-mode");
    setShowEndGame(false);
  };

  const onGotoRanking = async () => {
    navigate("/ranking");
  };

  const onShowEndGame = () => {
    setShowEndGame(true);
  };

  const getPlayers = (players: PlayerDetails[]): PlayerDetails[] => {
    return players.filter((item) => item.userId !== user?.userId) || [];
  };

  const pullPlayers = async (gameId: string) => {
    const res = await Firebase.getPlayersByGame(gameId);
    setPlayers(sortPlayers(res));
  };

  const checkGameStart = () => {
    if (!user || !game || !players) {
      setInvitePlayers(true);
      return;
    }
    if (PlayerService.isWaitingForPlayers(user, game) && players.length <= 1) {
      setWaitFriends(false);
      setInvitePlayers(true);
    } else {
      setInvitePlayers(false);
      setWaitFriends(true);
    }
  };

  const checkGameOver = () => {
    if (players && game) {
      const activePlayers = PlayerService.getPlayersActivePlaying(players);
      if (game.mode === GameMode.PlayAlone && activePlayers.length <= 0) {
        setGameOver(true);
      }

      if (
        game.mode === GameMode.PlayWithFriends &&
        game.status !== GameStatus.WaitingPlayers &&
        activePlayers.length <= 1
      ) {
        setGameOver(true);
      }
    }
  };

  const loadGame = async (gameId: string) => {
    setGameId(gameId);
    Firebase.listenNewPlayers(gameId, (event: PlayersEvent) => {
      pullPlayers(gameId);
      setNewPlayer(event.newPlayer);
    });

    Firebase.listenGame(gameId, (game: GameDetails) => {
      setGame(game);
    });

    const game = await Firebase.getGame(gameId);
    setGame(game);
  };

  const onStartGame = async () => {
    const firstPlayer = PlayerService.getFirstPlayer(players || []);
    await Firebase.updateGame(gameId, {
      status: GameStatus.RollDice,
      turnUserId: firstPlayer.userId,
    });
  };

  const sortPlayers = (players: PlayerDetails[]): PlayerDetails[] => {
    return lodash.orderBy(players, "timeStamp", "asc");
  };

  const isNewPlayer = () =>
    newPlayer && user?.userId !== newPlayer?.userId ? true : false;
  console.log("Game Details:", game);

  return (
    <React.Fragment>
      <CssBaseline />
      {commonContent && (
        <MContainer className="container" maxWidth="md">
          <AppProvider value={pixiApp}>
            {user && players && (
              <HeaderAppBar
                player={PlayerService.getLocalPlayer(players, user)}
                gameOver={gameOver}
                gameId={gameId}
                content={commonContent}
                onCancelEndGame={onCancelEndGame}
                onConfirmEndGame={onConfirmEndGame}
                onShowEndGame={onShowEndGame}
                showEndGame={showEndGame}
                showInvite={invitePlayers}
                onOpenInvite={onOpenInvite}
                onCloseInvite={onCloseInvite}
                points={PlayerService.calCulatePlayerPoints(players, user)}
                magnifyingGlass={PlayerService.calCulateMagnfyingGlass(
                  players,
                  user
                )}
                avatar={user.profileUrl}
                name={user.name}
              />
            )}
            {content && commonContent && game && players && user && (
              <GameBoard
                gameOver={gameOver}
                content={content}
                game={game}
                players={players}
                user={user}
                commonContent={commonContent}
              />
            )}
            {user && game && (
              <FoterAppBar
                gameOver={gameOver}
                content={commonContent}
                user={user}
                game={game}
                onOpenInvite={() => {
                  setInvitePlayers(true);
                }}
                players={getPlayers(players || [])}
              />
            )}
          </AppProvider>
          {game &&
            user &&
            game.status === GameStatus.WaitingPlayers &&
            !gameOver && (
              <StartGame
                game={game}
                user={user}
                visible={waitFriends}
                content={commonContent}
                onShareGame={() => setInvitePlayers(true)}
                onStartGame={() => {
                  onStartGame();
                  setWaitFriends(false);
                }}
                onLeaveGame={onShowEndGame}
              />
            )}
          {players && gameOver && content && (
            <GameOverPopup
              content={commonContent}
              visible={gameOver}
              data={PlayerService.getPlayersGameRanking(players)}
              ok="ok"
              cancel="sdadas"
              onConfirm={onGotoRanking}
              onCancel={onConfirmEndGame}
            />
          )}
          {isNewPlayer() && (
            <Snackbar
              open={false}
              autoHideDuration={4000}
              onClose={() => {
                setNewPlayer(null);
              }}
            >
              <div className="alertModeContainer">
                <Alert
                  variant="filled"
                  severity="success"
                  className="alertModeContainerText"
                >
                  {newPlayer?.name}{" "}
                  {GenericContent.getKeyValue(
                    commonContent,
                    ContentKey.USER_HAS_CONNECTED
                  )}
                </Alert>
              </div>
            </Snackbar>
          )}
        </MContainer>
      )}
    </React.Fragment>
  );
};
export default GameScreen;
